import { IoIosArrowRoundForward } from 'react-icons/io';
import { IoTriangle } from 'react-icons/io5';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { ChainId, WRAPPED_SOL } from '@shared/utils/config/networks';
import { toSpecialFixed } from '@/lib/misc/utils';
import ImageWithFallback from '../shared/ImageWithFallback';
import { haveDetails } from '@/lib/asset/nativeAddressHelper';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import NormieAssetModal from './NormieAssetModal';
export default function TopMobileResults({
  searchResult,
  timeFrame,
  onTokenClick
}) {
  const router = useRouter();
  const change = parseFloat(searchResult?.tokenInfo?.results[0][`change${timeFrame}`]);
  const isMobile = useIsMobile();
  searchResult.address = searchResult?.token?.symbol?.includes('BNB') ? '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c' : searchResult?.token?.symbol?.includes('AVAX') ? '0x0000000000000000000000000000000000000000' : searchResult.address;
  searchResult.token.symbol = searchResult?.token?.symbol?.includes('AVAX') ? 'AVAX' : searchResult?.token?.symbol;
  searchResult.token.networkId = searchResult?.token?.symbol?.includes('BNB') ? ChainId.BSC : searchResult?.token?.networkId;
  const tokenItem = searchResult?.token;
  const isEthereum = tokenItem?.symbol === 'WETH' || tokenItem?.symbol === 'ETH';
  const isSolana = tokenItem?.address === WRAPPED_SOL;
  const tokenImage = isEthereum || isSolana ? getNetworkLogo(Array.isArray(tokenItem.networkId) ? tokenItem.networkId[tokenItem.networkId.length - 1] : tokenItem.networkId) : tokenItem?.info?.imageThumbUrl || tokenItem?.info?.imageLargeUrl || tokenItem?.info?.imageSmallUrl;
  const changeUp = toSpecialFixed(change * 100, 2)?.value;
  const changeDown = toSpecialFixed(Math.abs(change * 100), 2).value;
  const tokenPrice = searchResult?.prices ? searchResult?.prices[0].priceUsd.toLocaleString(undefined, {
    maximumFractionDigits: 2
  }) : '0';
  const [isModalOpen, setIsOpenModal] = useState(false);
  function toggleModal() {
    setIsOpenModal(!isModalOpen);
  }
  function handleClick() {
    if (onTokenClick) {
      onTokenClick(tokenItem);
      return;
    }
    router.push(`/asset?address=${tokenItem.address}&networkId=${tokenItem.networkId}`);
  }
  function handleTokenClick() {
    if (haveDetails(tokenItem) || isEthereum) {
      toggleModal();
    } else {
      handleClick();
    }
  }
  return <>
      <div onClick={() => handleTokenClick()} key={`${tokenItem?.name}`} className={`${isMobile ? 'h-[70px]' : 'h-[80px]'} flex px-4 w-full justify-between items-center hover:cursor-pointer md:hover:bg-genius-blue transition-colors`}>
        <div className='flex items-center gap-3 relative'>
          <ImageWithFallback src={tokenImage} width={24} height={24} alt='token-logo' className='rounded-full' data-sentry-element="ImageWithFallback" data-sentry-source-file="TopMobileResults.tsx" />
          <div className='flex-col justify-start text-left '>
            <div className={`font-light text-base/4 text-genius-cream flex flex-col gap-y-1`}>
              {tokenItem?.symbol.replace('W', '').replace('.e', '')}

              {haveDetails(tokenItem) || isEthereum ? <div className='flex items-center text-[12px] text-genius-cream/50'>
                  {tokenItem?.name?.includes('BTC') ? 'Bitcoin' : tokenItem?.name.replace('Wrapped', '')}{' '}
                  Details <IoIosArrowRoundForward className='w-[16px] h-[16px]' />{' '}
                </div> : <div className='flex items-center text-[12px] text-genius-cream/50'>
                  {tokenItem?.name?.includes('SOL') ? 'Solana' : tokenItem?.name?.includes('AVAX') ? 'Avalanche' : tokenItem?.name?.includes('BNB') ? 'Binance' : tokenItem?.symbol.replace('W', '').replace('.e', '')}
                </div>}
            </div>
          </div>
        </div>
        <div className='flex flex-col text-right gap-y-2 max-w-18 text-wrap'>
          <p className='text-base/4 text-genius-cream text-right text-wrap'>${tokenPrice}</p>
          <div className='flex gap-1 items-center justify-end text-right'>
            {change >= 0 ? <div className='flex items-center text-right'>
                <IoTriangle color='#34D399' size={12} />
                <p className='text-xs text-gray-400 ml-1 text-right'>{`${changeUp}%`}</p>
              </div> : <div className='flex items-center text-right'>
                <IoTriangle color='#FF5B5B' size={12} className='rotate-180' />
                <p className='text-xs text-red-400 ml-1 text-right'>{`${changeDown}%`}</p>
              </div>}
          </div>
        </div>
      </div>
      <NormieAssetModal isMobile={isMobile} onTokenClick={() => handleClick()} isModalOpen={isModalOpen} toggleModal={toggleModal} token={searchResult} change={change} data-sentry-element="NormieAssetModal" data-sentry-source-file="TopMobileResults.tsx" />
    </>;
}